import React from 'react';
import { Activity, Clock, CheckCircle, XCircle } from 'lucide-react';
import './shared-analytics.css';

const DosesAnalytics = () => {
  return (
    <div className="doses-analytics">
      <div className="analytics-summary">
        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#faf5ff', color: '#7c3aed' }}>
            <Activity size={24} />
          </div>
          <div className="card-content">
            <h3>Doses Today</h3>
            <div className="card-value">94</div>
            <div className="card-change positive">+8 from yesterday</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#f0fdf4', color: '#16a34a' }}>
            <CheckCircle size={24} />
          </div>
          <div className="card-content">
            <h3>Completed</h3>
            <div className="card-value">67</div>
            <div className="card-change positive">71% success rate</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#fef2f2', color: '#dc2626' }}>
            <XCircle size={24} />
          </div>
          <div className="card-content">
            <h3>Missed</h3>
            <div className="card-value">27</div>
            <div className="card-change negative">29% miss rate</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#f0f9ff', color: '#0891b2' }}>
            <Clock size={24} />
          </div>
          <div className="card-content">
            <h3>Avg. Delay</h3>
            <div className="card-value">18min</div>
            <div className="card-change positive">-5min improvement</div>
          </div>
        </div>
      </div>

      <div className="content-placeholder">
        <h3>Daily Medication Dosing Analytics</h3>
        <p>Comprehensive tracking of medication dosing patterns and timing.</p>
        <ul>
          <li>Real-time dose tracking</li>
          <li>Missed dose identification</li>
          <li>Optimal timing recommendations</li>
          <li>Dose effectiveness correlation</li>
        </ul>
      </div>
    </div>
  );
};

export default DosesAnalytics;
